/** @type {import("@mui/material").SxProps<Theme>} */

const styles = (theme, color = 'primary') => ({
  container: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
      margin: '0 auto',
      maxWidth: 'inherit',
    },
  },
  topTag: {
    height: 30,
    backgroundColor: theme.palette[color].buttonColor,
    color: theme.palette[color].contrast,
    width: '220px',
    m: '0 auto',
    textAlign: 'center',
    borderRadius: '8px 8px 0 0',
  },

  // head
  head: {
    container: {
      textAlign: 'center',
      p: 0,
    },
    containerWithImage: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      // bgcolor: theme.palette[color].offerMain,
      p: 0,
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: '6.5rem',
      // bgcolor: theme.palette[color].offerMain,
    },
    preTitle: {
      color: theme.palette[color].contrastText,
      paddingTop: '1rem',
    },
    offerCardImgHeader: {
      height: '7.938rem',
      position: 'relative',
    },
    title: {
      color: theme.palette[color].contrastText,

      p: '0 1rem 1rem',
    },
    image: {},
    contractTag: {
      contractText: {
        color: theme.palette.secondary.mobileActiveToggleBackgroundLight,
        textAlign: 'left',
      },
      height: '28px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    mobileContractText: {
      color: theme.palette.primary.main,
    },
  },

  brandPriceText: {
    paddingTop: 1,
    // paddingBottom: 2,
    // fontSize: '1rem',
    color: theme.palette.primary.textColor3,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  brandPrice: {
    // fontWeight: 400,
    // fontSize: '1.125rem',
    color: theme.palette.primary.textColor3,
  },
  // carousel
  contentCarousel: {
    display: 'flex',
    flexDirection: 'row',
  },
  prevArrow: {
    backgroundColor: theme.palette.primary.arrows,
    color: theme.palette.secondary.errorCTA,
  },
  nextArrow: {
    backgroundColor: theme.palette.primary.arrows,
    color: theme.palette.secondary.errorCTA,
  },
  offerCards: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '100%',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: '84%',
    },
    width: { sm: '90vw', md: '100%', lg: '73em' },
    display: { md: 'flex' },
    justifyContent: { md: 'center' },
    alignItems: { md: 'center' },
    flexDirection: { md: 'row' },
  },
  singleOfferCard: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '100%',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: '80%',
    },
    width: { sm: '90vw', md: '100%', lg: '50em' },
    display: { md: 'flex' },
    justifyContent: { md: 'center' },
    alignItems: { md: 'center' },
    flexDirection: { md: 'row' },
  },
  offerSlider: {
    centerSwiper: {
      '& .swiper-wrapper': {
        [theme.breakpoints.up('md')]: {
          display: 'flex',
          justifyContent: 'center',
        },
      },
    },
    swiper: {
      [theme.breakpoints.up('lg')]: {
        width: '73rem',
      },
      [theme.breakpoints.down('sm')]: {
        width: '98vw',
      },
      [theme.breakpoints.up('sm')]: {
        width: '100%',
      },
      [theme.breakpoints.up('md')]: {
        width: '100%',
      },
      // '& .swiper-wrapper': {
      //   [theme.breakpoints.up('md')]: {
      //     display: 'flex',
      //     justifyContent: 'center',
      //     gap: '1.5%',
      //   },
      // },
      '& .swiper-pagination-bullet-active': {
        backgroundColor: theme.palette.primary.buttonColor,
      },
      '& .content-carousel-mobile': {
        height: { xs: 'fit-content' },
        [theme.breakpoints.down('sm')]: {
          pt: 3,
          pl: 2.25,
          pb: 9,
          pr: 2.25,
        },
        [theme.breakpoints.up('sm')]: {
          pt: 0.25,
          pl: 3.75,
          pb: 5,
          pr: 3.75,
        },
        [theme.breakpoints.up('md')]: {
          pt: 0.25,
          pl: 1,
          pb: 5,
          pr: 1,
        },
      },
      '& .content-carousel-mobile .swiper-slide': {
        paddingBottom: '1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '50%',
        [theme.breakpoints.down('sm')]: {
          '&.swiper-slide-active': {
            // transform: 'scale(1.1)',
            width: '100% !important',
            '& .offer-card': {
              width: 'inherit',
              // maxWidth: '70vw',
            },
          },
          '&.swiper-slide-prev': {
            transform: 'scale3d(0.95,0.95,0.80)',
          },
          '&.swiper-slide-next': {
            transform: 'scale3d(0.95,0.95,0.80)',
          },
        },
        [theme.breakpoints.up('sm')]: {
          '& .offer-card': {
            width: '90%',
          },
        },
        [theme.breakpoints.up('md')]: {
          '& .offer-card': {
            width: 'unset',
          },
        },
        [theme.breakpoints.up('lg')]: {
          '& .offer-card': {
            width: '22.5rem',
            boxSizing: 'border-box',
          },
        },
      },
    },
  },
  priceIncreaseTagline: {
    // fontFamily: theme?.typography?.body1.fontFamily,
    // fontStyle: 'normal',
    // fontWeight: 400,
    // fontSize: '0.75rem',
    // lineHeight: '1rem',
    color: theme.palette.primary.textColor3,
    // marginTop: 'auto',
    marginBottom: '1.5rem',
    // paddingLeft: '1.5rem',
    // paddingRight: '1.5rem',
    // textAlign: 'center',
  },
  // body
  body: {
    container: { textAlign: 'center' },
    offerCardBodyTV: {
      // padding: '0rem',
      pl: '0px',
      pr: '0px',
    },
    offerBody: {
      width: '-webkit-fill-available',
      WebkitUserSelect: 'none',
      msUserSelect: 'none',
      userSelect: 'none',
      [theme.breakpoints.down('md')]: {
        textAlign: 'center',
      },
    },
    offerBodyTV: {
      width: '-webkit-fill-available',
      WebkitUserSelect: 'none',
      msUserSelect: 'none',
      userSelect: 'none',
      [theme.breakpoints.down('md')]: {
        textAlign: 'center',
      },
    },
    priceOne: {
      // fontSize: '1.875rem !important',
      // lineHeight: '1.6rem',
      textAlign: 'center',
      color: theme.palette.primary.textColor3,
    },
    priceTwo: {
      fontSize: '1.5rem !important',
      lineHeight: '2rem',
      textAlign: 'center',
      color: theme.palette.primary.textColor3,
    },
    contractText: {
      fontFamily: theme?.typography?.body1.fontFamily,
      textAlign: 'left',
      color: theme.palette.secondary.breadcrumbBackground,
    },
    addedSimText: {
      fontFamily: theme?.typography?.body1.fontFamily,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '0.775rem',
      lineHeight: '1.175rem',
      textAlign: 'center',
      marginTop: '0.5rem',
    },
    description: {
      color: theme.palette.primary.textColor3,
      textAlign: 'left',
      padding: '1rem 0',
      // span: {
      //   fontSize: '1em !important',
      // },
    },
    descriptionList: {
      padding: '0',
      paddingTop: '1rem',
      paddingBottom: '1rem',
      listStyle: 'disc !important',
      item: {
        p: '0px 0px 10px 0px',
        '& .item-icon': {
          borderRadius: '21.2px',
          objectFit: 'scale-down',
        },
        '& .text-item': {
          paddingLeft: '0.5rem',
          '& #tvChannelPopup': {
            color: theme.palette.primary.textColor3,
          },
        },
        dots: {
          padding: '0px',
          '& .text-item': {
            paddingLeft: '0.5rem',
            '& #tvChannelPopup': {
              color: theme.palette.primary.textColor3,
            },
          },
        },
      },
    },
    selectButton: {
      border: `3px solid ${theme.palette.primary.buttonColor}`,
      background: theme.palette.primary.contrastText,
      color: theme.palette.primary.buttonColor,
      width: '100%',
      height: '2.5rem',
      // fontSize: '1rem',
      // lineHeight: '1.5rem',
      textTransform: 'capitalize',
      '&:hover': {
        background: theme.palette.primary.buttonColor,
        color: theme.palette.primary.contrastText,
      },
      '&.Mui-disabled': {
        background: theme.palette.primary.buttonInactiveColor,
        border: `none`,
        color: `${theme.palette.primary.contrastText} !important`,
        height: '2.8rem',
      },
    },

    ctaSelected: {
      background: theme.palette.primary.buttonColor,
      border: `3px solid ${theme.palette.primary.buttonColor}`,
      color: theme.palette.secondary.contrastText,
      height: '2.8rem',
      '&:hover': {
        border: `3px solid ${theme.palette.primary.buttonPrimaryHoverColor}`,
        background: theme.palette.primary.buttonPrimaryHoverColor,
        color: theme.palette.primary.contrastText,
      },
      '&.Mui-disabled': {
        background: theme.palette.primary.buttonInactiveColor,
        border: `none`,
        color: `${theme.palette.primary.contrastText} !important`,
        height: '2.8rem',
        '&:hover': {
          background: theme.palette.primary.disabled,
          color: `${theme.palette.primary.contrastText} !important`,
        },
      },
    },

    ctaDisabled: {
      background: '#949595',
      border: `none`,
      color: '#FFFFFF !important',
      height: '2.8rem',
      '&:hover': {
        background: '#949595',
        color: '#FFFFFF',
      },
    },
    ctaCheck: {
      fontSize: '1.05rem',
      color: theme.palette.secondary.contrastText,
      marginLeft: '0.606rem',
    },

    promotionText: {
      fontFamily: theme?.typography?.body1.fontFamily,
      fontStyle: 'normal',
      fontWeight: 400,
      color: theme.palette.primary.textColor3,
      fontSize: '1rem',
      lineHeight: '1.375rem',
      textAlign: 'center',
    },
    multipleOfferSelectContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    multipleOfferCounter: {
      width: '2.125rem',
      height: '1.1875rem',
      backgroundColor: theme.palette.secondary.light,
      borderRadius: '4px',
    },
  },
  offerTitle: {
    color: theme.palette.primary.textColor3,
    pb: '1.5rem',
  },
  // footer
  footer: {
    moreInfo: {
      p: 0,
      color: theme.palette[color].contrastText,
      borderRadius: '0 0 20px 20px',
      // width: '250px',
      position: 'relative',
      // boxShadow: 'rgb(241 241 241) 0px 0px 10px 4px',
      [theme.breakpoints.down('md')]: {
        alignSelf: 'center',
        width: '-webkit-fill-available',
      },
      [theme.breakpoints.down('sm')]: {
        alignSelf: 'center',
        width: '100%',
      },
    },
    collapse: {
      color: theme.palette[color].contrastText,
      borderRadius: '0 0 20px 20px',
      // width: 'unset',
      [theme.breakpoints.down('md')]: {
        alignSelf: 'center',
        // width: 'inherit',
      },
    },
  },
  offerCard: {
    width: '250px',
    [theme.breakpoints.down('md')]: {
      width: 'inherit',
    },
    [theme.breakpoints.up('md')]: {
      width: 'auto',
      // '&:hover': { transform: 'scale(1.04)' },
    },
  },

  /* Single bundle Card styling for desktop mode */
  mainSingleContainer: {
    display: 'flex',
    width: '53.5rem',
    [theme.breakpoints.down('md')]: {
      width: 'inherit',
    },
    [theme.breakpoints.up('md')]: {
      width: 'inherit',
      // '&:hover': { transform: 'scale3d(1.1,1.1,1.1)' },
    },
  },
  singleStyledCard: {
    // transition: 'transform .3s ease-in-out',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: `0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 6px 6px -3px  ${theme.palette.primary.boxShadow2Dark}`,
  },
  singleStyledCardSelected: {
    // border: `3px solid ${theme?.palette.secondary.activeSlide}`,
    borderColor: `${theme?.palette.primary.OfferSelected}`,
  },
  boxSingleContainer: {
    width: '53.5rem',
    borderRadius: 1,
    flex: 1,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      margin: '0 auto',
      maxWidth: 'inherit',
    },
  },
  singleContainer: {
    textAlign: 'center',
    p: 0,
    height: '100%',
  },
  singleContainerWithImage: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    p: 0,
    height: '100%',
  },
  singleTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // minHeight: '6.5rem',
    bgcolor: theme.palette[color].offerMain,
    height: '100%',
  },
  SingleTitleContainerWithImage: {
    height: '100%',
  },
  contractSingleTag: {
    bgcolor: theme.palette.primary.textColor3,
    contractSingleText: {
      color: theme.palette.secondary.contrastText,
      textAlign: 'center',
      lineHeight: '1.875rem',
    },
    padding: '0.25rem 0',
  },
  contractSingleTagSelected: {
    bgcolor: theme.palette.primary.textColor3,
    contractSingleText: {
      color: theme.palette.secondary.contrastText,
      textAlign: 'center',
      lineHeight: '1.875rem',
    },
  },
  singleDescription: {
    color: theme.palette.primary.textColor3,
    padding: '0rem 0 1rem 0',
  },
  singleDescriptionList: {
    padding: '0px 0px 8px 0px',
    // paddingLeft: '1rem !important',
    paddingBottom: '24px',
    item: {
      p: '0px 0px 0px 0px',
      '& .item-icon': {
        borderRadius: '21.2px',
        objectFit: 'scale-down',
      },
      '& .text-item': {
        paddingLeft: '0.5rem',
        '& #tvChannelPopup': {
          color: theme.palette.primary.textColor3,
        },
      },
    },
  },
  singleBodycontainer: {
    padding: '0.5rem 2rem 0 2rem',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.backgroundColor4,
  },
  singlePreTitle: {
    color: theme.palette[color].contrastText,
    // fontWeight: 400,
    // fontSize: 14,
    // fontFamily: 'eir-regular',
    paddingTop: '1rem',
  },
  singleTitle: {
    color: theme.palette[color].contrastText,
    // fontFamily: 'eir-medium',
    // fontSize: '1.5rem',
    p: '0 1rem 1rem',
  },
  singlePriceOne: {
    // fontSize: '1.5rem !important',
    lineHeight: '1.5rem',
    textAlign: 'center',
    color: theme.palette.primary.textColor3,
  },
  singlePriceTwo: {
    fontSize: '1.5rem !important',
    lineHeight: '2rem',
    textAlign: 'center',
    color: theme.palette.primary.textColor3,
  },
  singleContractText: {
    // fontFamily: theme?.typography?.body1.fontFamily,
    // fontStyle: 'normal',
    // fontWeight: 400,
    // fontSize: '1rem',
    // lineHeight: '1.375rem',
    paddingLeft: '0.5em',
    color: theme.palette.primary.textColor3,
  },
  singleContractTextAMonth: {
    fontFamily: theme?.typography?.body1.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.375rem',
    color: theme.palette.primary.offerPromo,
    marginTop: 'auto',
    paddingLeft: '5px',
    marginBottom: '2px',
  },
  singlePromotionText: {
    fontFamily: theme?.typography?.body1.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    color: theme.palette.primary.offerPromo,
    fontSize: '0.875rem',
    lineHeight: '1.375rem',
  },
  singleButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '9.625rem',
    maxWidth: '9.625rem',
    [theme.breakpoints.down('md')]: {
      pt: '1rem',
      pl: '2rem',
    },
  },
  singleSelectButton: {
    border: `3px solid ${theme.palette.primary.buttonColor}`,
    background: theme.palette.primary.contrastText,
    color: theme.palette.primary.buttonColor,
    width: '8.438rem',
    minHeight: '2.5rem',
    // fontFamily: theme?.typography?.h4.fontFamily,
    // fontStyle: 'normal',
    // fontWeight: 'inherit',
    // fontSize: '1rem',
    // lineHeight: '1.5rem',
    textTransform: 'capitalize',
    padding: '0rem',
    '&:hover': {
      background: theme.palette.primary.buttonColor,
      color: theme.palette.primary.contrastText,
    },
    '&.Mui-disabled': {
      background: theme.palette.primary.contrastText,
      border: `3px solid ${theme.palette.primary.buttonInactiveColor}`,
      color: `${theme.palette.primary.buttonInactiveColor} !important`,
      height: '2.8rem',
    },
  },
  singleCtaSelected: {
    background: theme.palette.primary.buttonColor,
    // border: `3px solid ${theme.palette.secondary.greenCta}`,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      border: `3px solid ${theme.palette.primary.buttonPrimaryHoverColor}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
    },
  },
  singleCtaCheck: {
    fontSize: '1.05rem',
    color: theme.palette.secondary.contrastText,
    marginLeft: '0.606rem',
  },
  singlePriceIncreaseTagline: {
    fontFamily: theme?.typography?.body1.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.4375rem',
    color: theme.palette.primary.offerPromo,
    mt: 1,
  },
});

export default styles;
